<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      積替運搬詳細
    </h2>

    <accept-pickup-detail
      :order-id="orderId"
    />
  </v-container>
</template>
<script>
import AcceptPickupDetail from '../../shared/_AcceptPickupDetail.vue'
export default {
  name: 'DriverOrderAcceptPickup',
  components: {
    AcceptPickupDetail,
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [],
      orderId: null,
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.orderId = parseInt(this.$route.params.id);
    this.breadcrumbs = []
    if (this.$route.query.d !== undefined) {
      this.breadcrumbs.push({ text: 'ダッシュボード', disabled: false, to: '/driver/home', exact: true })
    } else {
      this.breadcrumbs.push({ text: '受注一覧', disabled: false, to: '/driver/orders/accepts', exact: true })
    }
    this.breadcrumbs.push({ text: '積替運搬詳細', disabled: true, to: '' })
  },
  methods: {
  }
}
</script>
